import React from 'react'
import Header from "../inc/Header"
import { Link } from 'react-router-dom';
import eyecheckup from "../images/eye check up misaa.jpg";
import eyecheckup2026 from "../images/Eye check.jpg";
import freeeyecheckup from "../images/FREE EYE CHECK-UP CAMP 2026.jpg"
function FreeEye() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />



            <div className='bestberhamporeschoolmis'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/Gallery" style={{ color: "darkblue" }} >Back</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">M.I.S.A.A. FREE EYE CHECK-UP CAMP 2026

                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>


            <div className="album py-1">
                <div className="container">
                    <div className='row'>
                        <div className="col-md-4 mt-3">
                            <div className="card" >
                                <img src={eyecheckup} className="card-img-top" alt="eyecheckup" />
                           
                            </div>
                        </div>
                          <div className="col-md-4 mt-3">
                            <div className="card" >
                                <img src={eyecheckup2026} className="card-img-top" alt="eyecheckup2026" />
                            
                            </div>
                        </div>
                          <div className="col-md-4 mt-3">
                            <div className="card" >
                                <img src={freeeyecheckup} className="card-img-top" alt="freeeyecheckup" />
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<br/>

        </div>
    )
}

export default FreeEye